module.exports = __webpack_public_path__ + "static/media/flower1.e7572b71.png";